import { Box, Typography } from '@mui/material'
import React from 'react'

const Footer = () => {
    return (
        <>
        <Box className="footer">
            <Typography className='fs-12' sx={{color: '#FFFFFF80'}}>
                Copyrights &copy; {new Date().getFullYear()} <span style={{color:"#f2674a"}}> Wolfpack </span>Financial Inc. All Rights Reserved.
            </Typography>
        </Box>
        </>
    )
}

export default Footer
